export default function HouseIcon(props: React.SVGProps<any>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 20 20" {...props}>
      <g transform="translate(-28 -35)" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g stroke="currentColor" strokeWidth={2}>
          <path d="M31.438 54.063h13.125a2.5 2.5 0 002.5-2.5v-9.375L38 35.938l-9.062 6.25v9.375a2.5 2.5 0 002.5 2.5z" />
          <path d="M35.187 49.687a2.5 2.5 0 012.5-2.5h.625a2.5 2.5 0 012.5 2.5v4.375h-5.625v-4.375z" />
        </g>
      </g>
    </svg>
  );
}
